import React from 'react';
import './ActionFooter.css';

/**
 * ActionFooter - A sticky bottom bar for page-level actions (save, cancel, etc.)
 *
 * Sticks to the bottom of the visible viewport within the scrolling layout content.
 * Keeps actions always accessible without needing to scroll down.
 *
 * Usage:
 *   <ActionFooter>
 *     <Button variant="secondary" onClick={handleCancel}>Cancelar</Button>
 *     <Button type="submit" form="my-form">Guardar</Button>
 *   </ActionFooter>
 *
 * Props:
 *   children  – action buttons / any content
 *   align     – 'left' | 'center' | 'right' (default: 'right')
 *   className – extra CSS class names
 */
const ActionFooter = ({ children, align = 'right', className = '' }) => {
  return (
    <div className={`action-footer action-footer--${align} ${className}`.trim()}>
      <div className="action-footer__inner">
        {children}
      </div>
    </div>
  );
};

export default ActionFooter;
